module.exports = __webpack_public_path__ + "static/media/30_tn.4faa1325.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/30_tn.jpg
// module id = 339
// module chunks = 0